import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const ActivityFeedPage = lazy(async () => {
  const m = await import("@/features/activity/components/activity-feed-page");
  return { default: m.ActivityFeedPage };
});

function ActivityPageWrapper() {
  return (
    <Suspense fallback={null}>
      <ActivityFeedPage />
    </Suspense>
  );
}

export const activityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/activity",
  component: ActivityPageWrapper,
});
